<template>
  <div class="row mt-5">
    <div class="col-12">
      <div class="col-12 text-end">
        <button
          type="button"
          class="btn bg-gradient-warning me-2"
          @click.prevent="apagarExerciciosSelecionados"
          v-if="state.treinoElaborado.some(x => x.checkCopy)"
        >
          <i class="fas fa-trash me-2"></i>
          Apagar Selecionados
        </button>
        <button type="button" class="btn bg-gradient-danger" @click.prevent="apagarTodosExercicios"
          v-if="state.treinoElaborado.length > 0">
          <i class="fas fa-trash-alt me-2"></i>
          {{ $t('deleteAllExercises') }}
        </button>
      </div>
      <div class="form-group d-flex">
        <label for="" class="me-3">{{ $t('observations') }}: </label>
        <textarea rows="3" class="w-100" style="resize: none" v-model="state.observation" />
      </div>
    </div>

    <div class="col-12 table-responsive">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="p-0 pe-2" style="width: 5%">
              <!-- Checkbox Marcar Todos -->
              <input
                v-model="state.checkAll"
                @change="marcarTodos"
                class="form-check-input border"
                type="checkbox"
                title="Marcar/Desmarcar todos"
              />
            </th>
            <th scope="col" class="p-0" style="width: 10%">{{ $t('exercise') }}</th>
            <th scope="col" class="p-0" v-if="!hasCardioExercises">{{ $t('loads') }}</th>
            <!-- Colunas para exercícios de peso -->
            <th scope="col" class="p-0 text-center" style="width: 4%" v-if="!hasCardioExercises">
              S
            </th>
            <th scope="col" class="p-0 text-center" style="width: 4%" v-if="!hasCardioExercises">
              REP
            </th>
            <th scope="col" class="p-0 text-center" style="width: 4%" v-if="!hasCardioExercises">
              TON
            </th>
            <th scope="col" class="p-0 text-center" style="width: 4%" v-if="!hasCardioExercises">
              PM
            </th>
            <th scope="col" class="p-0 text-center" style="width: 4%" v-if="!hasCardioExercises">
              IMR
            </th>
          </tr>
        </thead>

        <tbody class="text-sm">
          <draggable :list="state.treinoElaborado" tag="transition-group" item-key="id" @start="state.drag = true"
            @end="state.drag = false">
            <template #item="{ element, index }">
              <tr>
                <td class="align-middle">
                  <!-- Checkbox individual -->
                  <input
                    v-if="(element.series && element.series.length > 0) || element.is_cardio"
                    v-model="element['checkCopy']"
                    @click="listaExerciciosParaCopiar(index)"
                    class="mb-1 form-check-input border"
                    type="checkbox"
                    value="1"
                  /><br />
                  <span class="pointer" data-bs-toggle="tooltip" :data-bs-original-title="$t('delete')">
                    <i class="fas fa-trash text-secondary" style="font-size: 1.2rem"
                      @click="deletarExercicio(element, index)"></i>
                  </span>
                </td>
                <td class="align-middle" style="width: 20%">
                  <div>
                    <!-- Para exercícios de cardio -->
                    <template v-if="element.is_cardio">
                      <div class="cardio-exercise-name">
                        <select v-if="isEditMode" class="form-control custom-select form-control-sm mb-2"
                          name="cardio_exercises" v-model="element.exercise_id"
                          @change="mudaExercicioCardio($event.target.value, element)">
                          <option v-for="(item, index) in state.exercicios" :key="index" :value="item.id"
                            :selected="item.id === element.exercise_id">
                            {{ item.name }}
                          </option>
                        </select>
                        <div v-else class="mb-2">
                          <strong>{{ getExerciseName(element.exercise_id) }}</strong>
                        </div>
                        <div class="mt-2">
                          <small class="text-muted">
                            <strong>Método:</strong>
                            {{ getMetodoName(element.cardio_method_id) }} |
                            <strong>Modalidade:</strong>
                            {{ getModalidadeName(element.cardio_modality_id) }}
                          </small>
                        </div>
                      </div>
                    </template>
                    <!-- Para exercícios de peso -->
                    <template v-else>
                      <template v-if="element.max_load_test == null || element.max_load_test == 0">
                        {{ element.exercise.name }}
                      </template>
                      <template v-else>
                        <select class="form-control custom-select form-control-sm" name="tested_exercises"
                          v-model="element.exercise_id" @change="mudaExercicioTestado($event.target.value, element)">
                          <option v-for="(item, index) in state.exerciciosTestados" :key="index"
                            :value="item.exercise_id">
                            {{ item.exercise.name }}
                          </option>
                        </select>
                      </template>
                    </template>
                  </div>
                  <div class="mt-2" v-if="!element.is_cardio">
                    {{ $t('maxLoad') }}: {{ element.max_load_test }}
                  </div>
                </td>
                <td class="d-flex">
                  <!-- Para exercícios de peso -->
                  <template v-if="!element.is_cardio">
                    <table v-for="(load, loadIndex) in element.series" :key="loadIndex">
                      <tr>
                        <td rowspan="2" style="text-align: center; vertical-align: middle; height: 30px">
                          <input class="form-control form-control-sm carga-input" type="text" v-model="load.load"
                            v-maska="'###'" @change="eventChangeExerciseLoad(index, loadIndex)"
                            style="width: 60px; height: 65px" />
                        </td>
                        <td>
                          <input class="form-control form-control-sm serie-input" type="text" v-model="load.series"
                            v-maska="'###'" @keyup="addCargaExercicio(index, loadIndex)" style="width: 50px" />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input class="form-control form-control-sm repeticao-input" type="text"
                            v-model="load.repetitions" v-maska="'###'" @keyup="addCargaExercicio(index, loadIndex)"
                            style="width: 50px" />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input class="form-control form-control-sm" type="text" v-maska="'###'"
                            :disabled="!parseInt(element.max_load_test) > 0" v-model="load.perc_load"
                            @change="calcularCarga(index, loadIndex, 'perc')" style="width: 60px" />
                        </td>
                        <td class="text-center">
                          <span class="pointer" data-bs-toggle="tooltip" :data-bs-original-title="$t('delete')">
                            <i class="fas fa-trash text-secondary" style="font-size: 1.2rem"
                              @click="removerSerie(index, loadIndex)"></i>
                          </span>
                        </td>
                      </tr>
                    </table>
                    <div class="d-grid">
                      <button type="button" class="ms-3 btn btn-sm font-weight-normal btn-outline-info p-1"
                        @click="copiaZonas(index)" :title="$t('copyZones')" style="font-size: 0.7rem">
                        {{ $t('copyZones') }}
                      </button>

                      <button type="button" class="ms-3 btn btn-sm font-weight-normal btn-outline-info p-1"
                        @click="colarZonas(index)" v-if="CanPasteZones" :title="$t('pasteZones')"
                        style="font-size: 0.7rem">
                        {{ $t('pasteZones') }}
                      </button>
                    </div>
                  </template>

                  <!-- Para exercícios de cardio -->
                  <template v-else>
                    <div class="cardio-details">
                      <!-- Tabela editável para cardio -->
                      <div class="table-responsive">
                        <table class="table table-sm table-bordered">
                          <thead class="table-light">
                            <tr>
                              <th class="text-center" style="width: 8%">Estágio</th>
                              <th class="text-center" style="width: 12%">Distancia (Metros)</th>
                              <th class="text-center" style="width: 15%">
                                {{
                                  getCardioMethodType(element) === 'continuo'
                                    ? 'Tempo (Hora/Min/Seg)'
                                    : 'Tempo (Min/seg)'
                                }}
                              </th>
                              <th class="text-center" style="width: 12%"
                                v-if="getCardioMethodType(element) === 'continuo'">
                                Pace (min/km)
                              </th>
                              <th class="text-center" style="width: 8%"
                                v-if="getCardioMethodType(element) === 'continuo'">
                                VO2/t
                              </th>
                              <th class="text-center" style="width: 8%"
                                v-if="getCardioMethodType(element) === 'continuo'">
                                FCtr
                              </th>
                              <th class="text-center" style="width: 15%"
                                v-if="getCardioMethodType(element) === 'intervalado'">
                                T. Recuperação (Min/Seg)
                              </th>
                              <th class="text-center" style="width: 8%"
                                v-if="getCardioMethodType(element) === 'intervalado'">
                                Carga
                              </th>
                              <th class="text-center" style="width: 8%"
                                v-if="getCardioMethodType(element) === 'intervalado'">
                                FCA
                              </th>
                              <th class="text-center" style="width: 8%">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(detail, detailIndex) in element.cardio_details" :key="detailIndex">
                              <td class="text-center">
                                <input class="form-control form-control-sm text-center" type="number"
                                  v-model="detail.stage" min="1" style="width: 80px" />
                              </td>
                              <td class="text-center">
                                <input class="form-control form-control-sm text-center" type="number"
                                  v-model="detail.distance" min="0" style="width: 100px" />
                              </td>
                              <td class="text-center">
                                <input class="form-control form-control-sm text-center" type="text"
                                  v-model="detail.time" :v-maska="getCardioMethodType(element) === 'continuo'
                                      ? '##:##:##'
                                      : '##:##'
                                    " :placeholder="getCardioMethodType(element) === 'continuo'
                                      ? '00:00:00'
                                      : '00:00'
                                    " style="width: 120px" />
                              </td>
                              <td class="text-center" v-if="getCardioMethodType(element) === 'continuo'">
                                <input class="form-control form-control-sm text-center" type="number"
                                  v-model="detail.pace" step="0.01" min="0" style="width: 100px" />
                              </td>
                              <td class="text-center" v-if="getCardioMethodType(element) === 'continuo'">
                                <input class="form-control form-control-sm text-center" type="number"
                                  v-model="detail.vo2_per_time" step="0.01" min="0" style="width: 80px" />
                              </td>
                              <td class="text-center" v-if="getCardioMethodType(element) === 'continuo'">
                                <input class="form-control form-control-sm text-center" type="number"
                                  v-model="detail.fctr" min="0" style="width: 80px" />
                              </td>
                              <td class="text-center" v-if="getCardioMethodType(element) === 'intervalado'">
                                <input class="form-control form-control-sm text-center" type="text"
                                  v-model="detail.recovery_time" v-maska="'##:##'" placeholder="00:00"
                                  style="width: 120px" />
                              </td>
                              <td class="text-center" v-if="getCardioMethodType(element) === 'intervalado'">
                                <input class="form-control form-control-sm text-center" type="number"
                                  v-model="detail.load" min="0" style="width: 80px" />
                              </td>
                              <td class="text-center" v-if="getCardioMethodType(element) === 'intervalado'">
                                <input class="form-control form-control-sm text-center" type="number"
                                  v-model="detail.fca" min="0" style="width: 80px" />
                              </td>
                              <td class="text-center">
                                <button type="button" class="btn btn-sm btn-outline-danger"
                                  @click="removerIntervaloCardio(index, detailIndex)" :title="$t('delete')"
                                  :disabled="element.cardio_details.length <= 1">
                                  <i class="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="text-center mt-2">
                        <button type="button" class="btn btn-sm btn-outline-primary"
                          @click="adicionarIntervaloCardio(index)">
                          <i class="fas fa-plus me-1"></i> Adicionar Estágio
                        </button>
                      </div>

                      <!-- TOTAIS DE CARDIO -->
                      <div v-if="element.resumo" class="mt-3">
                        <div class="row justify-content-center">
                          <div class="col-12">
                            <h6 class="text-center mb-2">Totais do Cardio:</h6>
                            <div class="row justify-content-center">
                              <div class="col-auto text-center me-3">
                                <div class="bg-light rounded p-2" style="min-width: 120px">
                                  <small class="text-muted">Estágios</small><br />
                                  <strong>{{ element.resumo.somaEstagio || 0 }}</strong>
                                </div>
                              </div>
                              <div class="col-auto text-center me-3">
                                <div class="bg-light rounded p-2" style="min-width: 120px">
                                  <small class="text-muted">Distância (m)</small><br />
                                  <strong>{{ element.resumo.somaDistancia || 0 }}</strong>
                                </div>
                              </div>
                              <div class="col-auto text-center me-3">
                                <div class="bg-light rounded p-2" style="min-width: 120px">
                                  <small class="text-muted">Tempo</small><br />
                                  <strong>{{
                                    formatarSegundosParaTempo(
                                      element.resumo.somaTempo || 0,
                                      getCardioMethodType(element) === 'intervalado',
                                    )
                                  }}</strong>
                                </div>
                              </div>
                              <div v-if="getCardioMethodType(element) === 'intervalado'"
                                class="col-auto text-center me-3">
                                <div class="bg-light rounded p-2" style="min-width: 120px">
                                  <small class="text-muted">Recuperação</small><br />
                                  <strong>{{
                                    formatarSegundosParaTempo(
                                      element.resumo.somaRecuperacao || 0,
                                      true,
                                    )
                                  }}</strong>
                                </div>
                              </div>
                              <div v-if="getCardioMethodType(element) === 'intervalado'"
                                class="col-auto text-center me-3">
                                <div class="bg-light rounded p-2" style="min-width: 120px">
                                  <small class="text-muted">Média Carga</small><br />
                                  <strong>{{ element.resumo.mediaCarga || 0 }}</strong>
                                </div>
                              </div>
                              <div v-if="getCardioMethodType(element) === 'intervalado'"
                                class="col-auto text-center me-3">
                                <div class="bg-light rounded p-2" style="min-width: 120px">
                                  <small class="text-muted">Média FCA</small><br />
                                  <strong>{{ element.resumo.mediaFca || 0 }}</strong>
                                </div>
                              </div>
                              <div v-if="getCardioMethodType(element) === 'continuo'" class="col-auto text-center me-3">
                                <div class="bg-light rounded p-2" style="min-width: 120px">
                                  <small class="text-muted">Média Pace</small><br />
                                  <strong>{{ element.resumo.mediaPace || 0 }}</strong>
                                </div>
                              </div>
                              <div v-if="getCardioMethodType(element) === 'continuo'" class="col-auto text-center me-3">
                                <div class="bg-light rounded p-2" style="min-width: 120px">
                                  <small class="text-muted">Média VO2/t</small><br />
                                  <strong>{{ element.resumo.mediaVo2t || 0 }}</strong>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </td>
                <!-- Para exercícios de peso -->
                <td class="text-center" v-if="!hasCardioExercises">
                  {{ calcularEstrategicos('S', index) }}
                </td>
                <td class="text-center" v-if="!hasCardioExercises">
                  {{ calcularEstrategicos('REP', index) }}
                </td>
                <td class="text-center" v-if="!hasCardioExercises">
                  {{ calcularEstrategicos('TON', index) }}
                </td>
                <td class="text-center" v-if="!hasCardioExercises">
                  {{ calcularEstrategicos('PM', index) }}
                </td>
                <td class="text-center" v-if="!hasCardioExercises">
                  {{ calcularEstrategicos('IMR', index) }}
                </td>
              </tr>
            </template>
          </draggable>
        </tbody>

        <tfoot v-if="!hasCardioExercises">
          <!-- Botões Copiar e Colar -->
          <tr>
            <td colspan="8">
              <button
                type="button"
                class="ms-3 btn btn-sm font-weight-normal btn-outline-info p-1"
                @click="copiarExerciciosSelecionados"
                style="font-size: 0.7rem"
              >
                {{ $t('copyExercises') }}
              </button>
              <button
                type="button"
                class="ms-3 btn btn-sm font-weight-normal btn-outline-info p-1"
                v-if="pasteExercises"
                @click="colarExerciciosSelecionados"
                style="font-size: 0.7rem"
              >
                {{ $t('pasteSelectedExercises') }}
              </button>
            </td>
          </tr>
          <tr class="font-weight-bold">
            <td></td>
            <td></td>
            <td class="text-end">{{ $t('totals') }}:</td>
            <!-- Para exercícios de peso -->
            <td class="text-center">
              {{ totalizadoresEstrategicos('S') }}
            </td>
            <td class="text-center">
              {{ totalizadoresEstrategicos('REP') }}
            </td>
            <td class="text-center">
              {{ totalizadoresEstrategicos('TON') }}
            </td>
            <td class="text-center">
              {{ totalizadoresEstrategicos('PM') }}
            </td>
            <td class="text-center">
              {{ totalizadoresEstrategicos('IMR') }}
            </td>
          </tr>
        </tfoot>
      </table>

      <div>
        <button type="button" class="ms-3 btn btn-sm font-weight-normal btn-outline-info p-1" v-if="pasteExercises"
          @click="colarExerciciosSelecionados" style="font-size: 0.7rem">
          {{ $t('pasteSelectedExercises') }}
        </button>
      </div>
    </div>

    <div class="col-12">
      <div class="row mt-5">
        <div class="col-12 text-end">
          <button type="button" class="ms-3 btn bg-gradient-primary" @click.prevent="salvar">
            {{ $t('save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, inject, onMounted, reactive, watch } from 'vue'
import planosTreinoRepository from '../../../../services/api/planosTreinoRepository'
import exercicioRepository from '../../../../services/api/exercicioRepository'
import metodoRepository from '../../../../services/api/metodoRepository'
import modalidadeRepository from '../../../../services/api/modalidadeRepository'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import draggable from 'vuedraggable'
import store from '@/store'

export default {
  props: {
    exerciciosProp: {
      type: Array,
      default: [],
    },
    exerciciosTestadosProp: {
      type: Array,
      default: [],
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    draggable,
  },
  emits: ['refreshWeek', 'update:exerciciosProp'],
  setup(props, { emit }) {
    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')

    // ✅ Flag para evitar loop infinito
    let isUpdatingFromChild = false

    watch(
      () => props.exerciciosProp,
      (newVal) => {
        console.log('🔍 [TabelaExerciciosElaborados] Watch disparado!')
        console.log('📥 newVal (prop do pai):', newVal.length, 'exercícios')
        console.log('📤 state.treinoElaborado (local):', state.treinoElaborado.length, 'exercícios')
        console.log('🚩 isUpdatingFromChild:', isUpdatingFromChild)

        // Se a mudança veio do próprio componente filho, ignorar
        if (isUpdatingFromChild) {
          console.log('✅ [TabelaExerciciosElaborados] Mudança veio do filho! Ignorando watch.')
          isUpdatingFromChild = false
          return
        }

        // Sincronizar apenas se realmente mudou
        if (JSON.stringify(newVal) !== JSON.stringify(state.treinoElaborado)) {
          console.log('⚠️ [TabelaExerciciosElaborados] Arrays diferentes! Sincronizando do pai...')
          state.treinoElaborado = []
          setarLista()
        } else {
          console.log('✅ [TabelaExerciciosElaborados] Arrays iguais! Ignorando.')
        }
      },
    )
    const store = useStore()

    onMounted(() => {
      state.treinoElaborado = []
      if (props.exerciciosTestadosProp.length > 0) {
        state.exerciciosTestados = [...props.exerciciosTestadosProp]
        state.observation = state.exerciciosTestados[0]['observation']
        setarLista()
      } else {
        setarLista()
      }

      // Carregar todos os exercícios para cardio
      carregarTodosExercicios()
      carregarMetodos()
      carregarModalidades()
    })

    const state = reactive({
      treinoElaborado: [],
      testedExercises: [],
      drag: false,
      exerciciosTestados: [],
      exercicios: [], // Lista de todos os exercícios para cardio
      metodos: [], // Lista de métodos para cardio
      modalidades: [], // Lista de modalidades para cardio
      observation: '',
      checkAll: false,
    })

    function setarLista() {
      state.treinoElaborado = props.exerciciosProp.map((item) => {
        // Verificar se é exercício de cardio
        const isCardio =
          item.is_cardio ||
          item.cardio_modality_id ||
          item.cardio_method_id ||
          (item.cardio_details && item.cardio_details.length > 0)

        if (isCardio) {
          // Para exercícios de cardio, garantir que cardio_details existe
          if (!item.cardio_details || item.cardio_details.length === 0) {
            item.cardio_details = [
              {
                stage: '',
                time: '',
                distance: '',
                recovery_time: '',
                load: '',
                fca: '',
                pace: '',
                vo2_per_time: '',
                fctr: '',
              },
            ]
          }
          // Marcar como cardio
          item.is_cardio = true

          // Calcular totais automaticamente para exercícios de cardio salvos
          if (item.cardio_details && item.cardio_details.length > 0 && item.cardio_method_id) {
            item.resumo = calcularTotaisCardio(item.cardio_details, item.cardio_method_id)
          }
        } else {
          // Para exercícios de peso, garantir que series existe
          if (!item.series || item.series.length === 0) {
            item.series = [
              {
                repetitions: '',
                load: '',
                perc_load: '',
                series: '',
              },
            ]
          }

          // Processar series para exercícios de peso
          item.series.forEach((serie) => {
            // Se perc_load não existir ou for vazio, calcular baseado na carga
            if (!serie['perc_load'] || serie['perc_load'] === '') {
              if (
                serie.load != '' &&
                parseInt(serie.load) > 0 &&
                item.max_load_test != '' &&
                parseInt(item.max_load_test) > 0
              ) {
                serie['perc_load'] = parseInt((parseInt(serie.load) * 100) / item.max_load_test)
              } else {
                serie['perc_load'] = ''
              }
            }
            // Se perc_load já existe (veio do banco), manter o valor original
          })
        }

        return item
      })
    }

    // Função para calcular totais automaticamente para exercícios de cardio salvos
    const calcularTotaisCardio = (cardioDetails, methodId) => {
      if (!cardioDetails || cardioDetails.length === 0) {
        return null
      }

      const resumo = {
        somaEstagio: 0,
        somaTempo: 0,
        somaDistancia: 0,
        somaRecuperacao: 0,
        mediaPace: 0,
        mediaCarga: 0,
        mediaVo2t: 0,
        mediaFca: 0,
      }

      let totalPace = 0
      let totalCarga = 0
      let totalVo2t = 0
      let totalFca = 0
      let countPace = 0
      let countCarga = 0
      let countVo2t = 0
      let countFca = 0

      // Determinar se é método contínuo ou intervalado
      const metodo = state.metodos.find((m) => m.id === methodId)
      const isContinuo =
        metodo &&
        (metodo.name.toLowerCase().includes('contínuo') ||
          metodo.name.toLowerCase().includes('continuo'))

      cardioDetails.forEach((detail) => {
        const estagios = parseInt(detail.stage) || 0

        // Somatórios comuns
        resumo.somaEstagio += estagios

        // Tempo: multiplicar pelo número de estágios
        const tempo = converterTempoParaSegundos(detail.time)
        resumo.somaTempo += estagios * tempo

        // Distância: multiplicar pelo número de estágios
        const distancia = parseInt(detail.distance) || 0
        resumo.somaDistancia += estagios * distancia

        if (isContinuo) {
          // Método contínuo
          if (detail.pace && !isNaN(parseFloat(detail.pace))) {
            totalPace += parseFloat(detail.pace)
            countPace++
          }
          if (detail.vo2_per_time && !isNaN(parseFloat(detail.vo2_per_time))) {
            totalVo2t += parseFloat(detail.vo2_per_time)
            countVo2t++
          }
        } else {
          // Método intervalado
          const tempoRecuperacao = converterTempoParaSegundos(detail.recovery_time)
          resumo.somaRecuperacao += estagios * tempoRecuperacao

          if (detail.load && !isNaN(parseFloat(detail.load))) {
            totalCarga += parseFloat(detail.load) * estagios
            countCarga++
          }
          if (detail.fca && !isNaN(parseFloat(detail.fca))) {
            totalFca += parseFloat(detail.fca) * estagios
            countFca++
          }
        }
      })

      // Calcular médias
      if (isContinuo) {
        resumo.mediaPace = countPace > 0 ? (totalPace / countPace).toFixed(1) : 0
        resumo.mediaVo2t = countVo2t > 0 ? (totalVo2t / countVo2t).toFixed(1) : 0
      } else {
        const totalEstagios = resumo.somaEstagio
        resumo.mediaCarga = totalEstagios > 0 ? (totalCarga / totalEstagios).toFixed(1) : 0
        resumo.mediaFca = totalEstagios > 0 ? (totalFca / totalEstagios).toFixed(1) : 0
      }

      return resumo
    }

    // Função para converter tempo para segundos
    const converterTempoParaSegundos = (tempo) => {
      if (!tempo || tempo === '') return 0

      if (tempo.includes(':')) {
        const partes = tempo.split(':')
        if (partes.length === 2) {
          // Formato MM:SS
          const minutos = parseInt(partes[0]) || 0
          const segundos = parseInt(partes[1]) || 0
          return minutos * 60 + segundos
        } else if (partes.length === 3) {
          // Formato HH:MM:SS
          const horas = parseInt(partes[0]) || 0
          const minutos = parseInt(partes[1]) || 0
          const segundos = parseInt(partes[2]) || 0
          return horas * 3600 + minutos * 60 + segundos
        }
      }

      return parseInt(tempo) || 0
    }

    // Função para formatar segundos de volta para formato de tempo
    const formatarSegundosParaTempo = (segundos, isIntervalado = false) => {
      if (!segundos || segundos === 0) return isIntervalado ? '00:00' : '00:00:00'

      const horas = Math.floor(segundos / 3600)
      const minutos = Math.floor((segundos % 3600) / 60)
      const segs = segundos % 60

      if (isIntervalado && horas === 0) {
        // Para método intervalado, retorna MM:SS se não há horas
        return `${minutos.toString().padStart(2, '0')}:${segs.toString().padStart(2, '0')}`
      } else {
        // Para método contínuo ou quando há horas, retorna HH:MM:SS
        return `${horas.toString().padStart(2, '0')}:${minutos
          .toString()
          .padStart(2, '0')}:${segs.toString().padStart(2, '0')}`
      }
    }

    function addCargaExercicio(listaIndex, loadIndex) {
      // ✅ CÓPIA AUTOMÁTICA: Se editou o primeiro exercício e há mais exercícios, copia série/repetição
      if (loadIndex >= 0 && listaIndex === 0 && state.treinoElaborado.length > 1) {
        copiarSerieRepeticao(loadIndex)
      }

      //console.log('a')
      const exercise = state.treinoElaborado[listaIndex]

      // Se for exercício de cardio, não adicionar carga
      if (exercise.is_cardio) {
        return
      }

      let countCargas = exercise['series'].length
      let ultimoItem = exercise['series'][countCargas - 1]
      //console.log(ultimoItem)
      if (ultimoItem.load > 0 || ultimoItem.repetitions > 0 || ultimoItem.series > 0) {
        let obj = {
          repetitions: '',
          load: '',
          perc_load: '',
          series: '',
        }
        exercise['series'].push(obj)
        //console.log(exercise["series"])
      }
    }

    function copiarSerieRepeticao(loadIndex) {
      let exercicioTestadoBase = state.treinoElaborado[0]['series'][loadIndex]
      state.treinoElaborado.forEach((obj, index) => {
        if (index > 0) {
          obj['series'][loadIndex]['repetitions'] =
            exercicioTestadoBase['repetitions'] !== '' ? exercicioTestadoBase['repetitions'] : 0
          obj['series'][loadIndex]['series'] =
            exercicioTestadoBase['series'] !== '' ? exercicioTestadoBase['series'] : 0
          addCargaExercicio(index, loadIndex)
        }
      })
    }

    function calcularCarga(listaIndex, loadIndex, tipo = '') {
      let item = state.treinoElaborado[listaIndex]

      // Se for exercício de cardio, não calcular carga
      if (item.is_cardio) {
        return
      }

      let itemCarga = item['series'][loadIndex]
      if (tipo == 'perc') {
        let result = (parseInt(item.max_load_test) * parseFloat(itemCarga.perc_load)) / 100
        state.treinoElaborado[listaIndex]['series'][loadIndex]['load'] = parseInt(result)
      } else {
        if (parseInt(item.max_load_test) > 0) {
          let result = (parseInt(itemCarga.load) * 100) / item.max_load_test
          state.treinoElaborado[listaIndex]['series'][loadIndex]['perc_load'] = parseInt(result)
        } else {
          state.treinoElaborado[listaIndex]['series'][loadIndex]['perc_load'] = 0
        }
      }
    }

    function removerSerie(listaIndex, loadIndex) {
      const exercise = state.treinoElaborado[listaIndex]

      // Se for exercício de cardio, não remover série
      if (exercise.is_cardio) {
        return
      }

      if (exercise['series'].length < 2) return
      exercise['series'].splice(loadIndex, 1)
    }

    function calcularEstrategicos(tipo, listaIndex) {
      let exercise = state.treinoElaborado[listaIndex]

      // Para exercícios de cardio, retornar valores apropriados ou 0
      if (exercise.is_cardio) {
        if (tipo === 'S') {
          // Para cardio, contar o número de intervalos
          return exercise.cardio_details ? exercise.cardio_details.length : 0
        } else if (tipo === 'REP') {
          // Para cardio, somar o tempo total em segundos
          let totalTime = 0
          if (exercise.cardio_details) {
            exercise.cardio_details.forEach((detail) => {
              if (detail.time) {
                const timeParts = detail.time.split(':')
                if (timeParts.length === 3) {
                  totalTime +=
                    parseInt(timeParts[0]) * 3600 +
                    parseInt(timeParts[1]) * 60 +
                    parseInt(timeParts[2])
                }
              }
            })
          }
          return totalTime
        } else {
          // Para outros tipos (TON, PM, IMR), retornar 0 para cardio
          return 0
        }
      }

      // Para exercícios de peso, manter a lógica original
      let response = 0
      if (tipo == 'S') {
        exercise.series.forEach((load) => {
          if (load.series != '' && parseInt(load.series) > 0) {
            response += parseInt(load.series)
          }
        })
      } else if (tipo == 'REP') {
        exercise.series.forEach((load) => {
          if (load.series != '' && load.repetitions != '') {
            response += parseInt(load.series) * parseInt(load.repetitions)
          }
        })
      } else if (tipo == 'TON') {
        exercise.series.forEach((load) => {
          if (load.series != '' && load.load != '' && load.repetitions != '') {
            response += parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)
          }
        })
      } else if (tipo == 'PM') {
        let ton = 0
        let rep = 0
        exercise.series.forEach((load) => {
          if (load.load != '' && load.series != '' && load.repetitions != '') {
            ton += parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)

            rep += parseInt(load.series) * parseInt(load.repetitions)
            //response += (parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)) / (parseInt(load.series) * parseInt(load.repetitions))
          }
        })
        /*if(parseFloat(ton / rep).toFixed(2) == 'NaN') {
            //console.log(exercise.series)
            console.log([ton / rep])
          }*/
        if (rep !== 0) {
          response = parseFloat(ton / rep).toFixed(2)
        }
      } else if (tipo == 'IMR') {
        let ton = 0
        let rep = 0
        exercise.series.forEach((load) => {
          if (load.load != '' && load.series != '' && load.repetitions != '') {
            ton += parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)

            rep += parseInt(load.series) * parseInt(load.repetitions)
            //response += (parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)) / (parseInt(load.series) * parseInt(load.repetitions))
          }

          /*if(load.series != '') {
              response += parseInt(load.series)
            }*/
        })
        if (rep === 0) return 0
        let pm = parseFloat(ton / rep).toFixed(2)
        if (!exercise.max_load_test) return 0
        let responsePM = parseInt((pm * 100) / exercise.max_load_test)
        //console.log(responsePM)
        return responsePM
      }
      return response
    }

    //const totalizadoresEstrategicos = computed(() => {
    function totalizadoresEstrategicos(tipo) {
      // let totais = {'S': 0, 'REP': 0,	'TON': 0,	'PM': 0,	'IMR': 0}
      let response = 0
      let responseIMR = 0
      let ton = 0
      let rep = 0
      let responsePM = 0

      // Filtrar exercícios de peso e cardio
      const pesoExercises = state.treinoElaborado.filter((exercise) => !exercise.is_cardio)
      const cardioExercises = state.treinoElaborado.filter((exercise) => exercise.is_cardio)

      // Calcular para exercícios de peso
      pesoExercises.forEach((exercise, index) => {
        if (tipo == 'S') {
          exercise.series.forEach((load) => {
            if (load.series != '' && parseInt(load.series) > 0) {
              response += parseInt(load.series)
            }
          })
        } else if (tipo == 'REP') {
          exercise.series.forEach((load) => {
            if (load.series != '' && load.repetitions != '') {
              response += parseInt(load.series) * parseInt(load.repetitions)
            }
          })
        } else if (tipo == 'TON') {
          exercise.series.forEach((load) => {
            if (load.series != '' && load.load != '' && load.repetitions != '') {
              response += parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)
            }
          })
        } else if (tipo == 'PM') {
          responsePM += parseFloat(
            calcularEstrategicos(tipo, state.treinoElaborado.indexOf(exercise)),
          )
        } else if (tipo == 'IMR') {
          responseIMR += parseFloat(
            calcularEstrategicos(tipo, state.treinoElaborado.indexOf(exercise)),
          )
        }
      })

      // Calcular para exercícios de cardio
      cardioExercises.forEach((exercise) => {
        if (tipo == 'S') {
          // Adicionar número de intervalos de cardio
          response += exercise.cardio_details ? exercise.cardio_details.length : 0
        } else if (tipo == 'REP') {
          // Adicionar tempo total de cardio
          if (exercise.cardio_details) {
            exercise.cardio_details.forEach((detail) => {
              if (detail.time) {
                const timeParts = detail.time.split(':')
                if (timeParts.length === 3) {
                  response +=
                    parseInt(timeParts[0]) * 3600 +
                    parseInt(timeParts[1]) * 60 +
                    parseInt(timeParts[2])
                }
              }
            })
          }
        }
        // Para TON, PM, IMR, cardio não contribui (já é 0)
      })

      if (tipo == 'IMR') {
        let exerciciosFiltrados = pesoExercises.filter((obj) => {
          let serieLength = obj.series.length
          let serieLoad = obj.series[serieLength - 1].perc_load
          if (
            parseInt(serieLoad) !== '' &&
            !isNaN(parseInt(serieLoad)) &&
            parseInt(serieLoad) > 0
          ) {
            return obj
          }
        })
        let responseIMRFinal = responseIMR / exerciciosFiltrados.length

        return isNaN(responseIMRFinal) ? 0 : parseInt(responseIMRFinal)
      }
      if (tipo == 'PM') {
        let exerciciosFiltrados = pesoExercises.filter((obj) => {
          let serieLength = obj.series.length
          let serieLoad = obj.series[serieLength - 1].load
          if (serieLoad !== '') {
            return obj
          }
        })

        return (responsePM / exerciciosFiltrados.length).toFixed(2)
      }
      return response
    }

    const salvar = async () => {
      console.log('🚀🚀🚀 [SALVAR] Função salvar() INICIADA!')
      console.log('🚀🚀🚀 [SALVAR] state.treinoElaborado:', state.treinoElaborado)
      console.log('🚀🚀🚀 [SALVAR] VERSÃO DO CÓDIGO: 2025-01-07 - Se você está vendo isto, o código novo está carregado!')

      // Separar exercícios de peso e cardio
      const pesoExercises = state.treinoElaborado.filter((exercise) => !exercise.is_cardio)
      const cardioExercises = state.treinoElaborado.filter((exercise) => exercise.is_cardio)

      console.log('🚀🚀🚀 [SALVAR] pesoExercises count:', pesoExercises.length)
      console.log('🚀🚀🚀 [SALVAR] cardioExercises count:', cardioExercises.length)

      // Salvar exercícios de peso
      if (pesoExercises.length > 0) {
        let pesoData = pesoExercises.map((exercise, index) => {
          if (exercise.id) {
            // ✅ Converter series para array plano (sem Vue reactivity)
            const plainSeries = exercise.series ? JSON.parse(JSON.stringify(exercise.series)) : []

            return {
              id: exercise.id,
              series: plainSeries,
              exercise_id: exercise.exercise_id,
              max_load_test: exercise.max_load_test,
              order: index + 1,
              observation: state.observation,
            }
          } else {
            const newExercise = JSON.parse(JSON.stringify(exercise))
            newExercise['order'] = index + 1
            newExercise['training_day'] = state.treinoElaborado[0]['training_day']
            newExercise['training_plan_week_id'] = state.treinoElaborado[0]['training_plan_week_id']
            newExercise['training_date'] = state.treinoElaborado[0]['training_date']
            return newExercise
          }
        })

        console.log('✅ Dados de peso a serem enviados:', JSON.stringify(pesoData, null, 2))

        try {
          store.commit('SET_SPLASH_SCREEN', true)
          let response = await planosTreinoRepository.PlanoTreinoAtualizarExerciciosDiaPost(
            pesoData,
          )
          if (response.data.success) {
            console.log('Exercícios de peso salvos com sucesso')
          }
        } catch (error) {
          console.error(error)
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: 'Erro ao salvar exercícios de peso!',
            text: error.message,
          })
          return
        }
      }

      // Salvar exercícios de cardio
      if (cardioExercises.length > 0) {
        for (let cardioExercise of cardioExercises) {
          let cardioData = {
            training_plan_group_id: cardioExercise.training_plan_group_id,
            cardio_modality_id: cardioExercise.cardio_modality_id,
            cardio_method_id: cardioExercise.cardio_method_id,
            vo2_max: cardioExercise.vo2_max || null,
            fcm: cardioExercise.fcm || null,
            perc_vo2_max: cardioExercise.perc_vo2_max || null,
            perc_fcm: cardioExercise.perc_fcm || null,
            observation: state.observation,
            cardio_details: cardioExercise.cardio_details.map((detail, index) => ({
              stage: parseInt(detail.stage) || 1,
              time: detail.time || '00:00:00',
              distance: parseInt(detail.distance) || 0,
              recovery_time: detail.recovery_time || '00:00:00',
              load: parseInt(detail.load) || 0,
              fca: parseInt(detail.fca) || 0,
              pace: parseFloat(detail.pace) || 0,
              vo2_per_time: parseFloat(detail.vo2_per_time) || 0,
              fctr: parseInt(detail.fctr) || 0,
            })),
          }

          console.log('Dados de cardio:', cardioData)

          try {
            let response
            if (cardioExercise.id) {
              // Update
              response = await planosTreinoRepository.PlanoTreinoAtualizarExerciciosCardioPorId(
                cardioExercise.id,
                cardioData,
              )
            } else {
              // Create
              response = await planosTreinoRepository.AdicionarExerciciosCardioGrupoPost(cardioData)
            }

            if (response.data.success) {
              console.log('Exercício de cardio salvo com sucesso')
            }
          } catch (error) {
            console.error(error)
            store.commit('SET_SPLASH_SCREEN', false)
            swal({
              icon: 'error',
              title: 'Erro ao salvar exercício de cardio!',
              text: error.message,
            })
            return
          }
        }
      }

      store.commit('SET_SPLASH_SCREEN', false)
      swal({
        icon: 'success',
        text: 'Exercícios ajustados com sucesso!',
      })
    }

    function deletarExercicio(item, index) {
      const exerciseName = item.is_cardio
        ? item.exercise?.name || 'Exercício de Cardio'
        : item.exercise.name

      swal({
        title: 'Tem certeza?',
        text: `Deseja deletar ${exerciseName}`,
        showCancelButton: true,
        confirmButtonText: 'Sim, quero deletar!',
        cancelButtonText: 'Não, cancelar!',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-success',
          cancelButton: 'btn bg-gradient-danger',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          if (item.id) {
            // Se for exercício de cardio, usar endpoint específico
            if (item.is_cardio) {
              deletarExercicioCardioConfirma(item.id, index)
            } else {
              deletarExercicioConfirma(item.id, index)
            }
          } else {
            // ✅ FIX: Remover localmente apenas exercícios sem ID
            // Verificar índice correto antes de remover
            const correctIndex = state.treinoElaborado.findIndex(ex =>
              ex.exercise_id === item.exercise_id &&
              !ex.id &&
              ex === item
            )
            if (correctIndex > -1) {
              console.log('🗑️ [TabelaExerciciosElaborados] Deletando exercício SEM ID')
              console.log('📊 Antes:', state.treinoElaborado.length, 'exercícios')
              state.treinoElaborado.splice(correctIndex, 1)
              console.log('📊 Depois:', state.treinoElaborado.length, 'exercícios')
              // ✅ Marcar flag antes de emitir
              isUpdatingFromChild = true
              // ✅ Emitir evento para atualizar o pai
              console.log('📤 Emitindo update:exerciciosProp')
              emit('update:exerciciosProp', [...state.treinoElaborado])
            }
          }
        }
      })
    }

    function deletarExercicioConfirma(id, index) {
      store.commit('SET_SPLASH_SCREEN', true)
      planosTreinoRepository
        .PlanoTreinoExerciciosDiaDelete(id)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            console.log('🗑️ [TabelaExerciciosElaborados] Deletando exercício COM ID:', id)
            console.log('📊 Antes:', state.treinoElaborado.length, 'exercícios')

            // ✅ FIX: Remover do array local ANTES de mostrar mensagem
            let itemIndex = state.treinoElaborado.findIndex(x => x.id == id)
            if (itemIndex > -1) {
              state.treinoElaborado.splice(itemIndex, 1)
            }

            console.log('📊 Depois:', state.treinoElaborado.length, 'exercícios')
            // ✅ Marcar flag antes de emitir
            isUpdatingFromChild = true
            // ✅ Emitir evento para atualizar o pai
            console.log('📤 Emitindo update:exerciciosProp')
            emit('update:exerciciosProp', [...state.treinoElaborado])

            swal({
              title: 'Removido!',
              text: 'Exercicio removido com sucesso!',
              icon: 'success',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            })
            // ✅ FIX: NÃO fazer refresh automático para evitar recarregar exercícios
            // O refresh() pode trazer de volta exercícios deletados
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          console.error(error.message)
          swal({
            icon: 'error',
            title: 'Erro ao deletar exercicio!',
            text: error.message,
          })
        })
    }

    function deletarExercicioCardioConfirma(id, index) {
      store.commit('SET_SPLASH_SCREEN', true)
      planosTreinoRepository
        .PlanoTreinoExerciciosCardioDiaDelete(id)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            // ✅ FIX: Remover do array local ANTES de mostrar mensagem
            let itemIndex = state.treinoElaborado.findIndex(x => x.id == id)
            if (itemIndex > -1) {
              state.treinoElaborado.splice(itemIndex, 1)
            }

            swal({
              title: 'Removido!',
              text: 'Exercício de cardio removido com sucesso!',
              icon: 'success',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            })
            // ✅ FIX: NÃO fazer refresh automático para evitar recarregar exercícios
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          console.error(error.message)
          swal({
            icon: 'error',
            title: 'Erro ao deletar exercício de cardio!',
            text: error.message,
          })
        })
    }

    function refresh() {
      if (state.treinoElaborado.length > 0 && state.treinoElaborado[0]['training_plan_week_id']) {
        router.push({
          path: '/elaborar-treino/elaborador',
          query: { week: state.treinoElaborado[0]['training_plan_week_id'] },
        })
        console.log('refreshWeek')
        emit('refreshWeek')
      } else {
        // Se não há exercícios, apenas emitir o evento de refresh
        emit('refreshWeek')
      }
      //router.go(0)
    }

    function mudaExercicioTestado(eventValue, element) {
      const exercicioIndex = state.treinoElaborado.findIndex((x) => x.id == element.id)
      const exercicioTestado = state.exerciciosTestados.find((x) => x.exercise_id == eventValue)
      state.treinoElaborado[exercicioIndex].exercise = exercicioTestado.exercise
      state.treinoElaborado[exercicioIndex].exercise_id = exercicioTestado.exercise_id
      state.treinoElaborado[exercicioIndex].max_load_test = exercicioTestado.max_load_test

      // Se for exercício de cardio, não processar series
      if (state.treinoElaborado[exercicioIndex].is_cardio) {
        return
      }

      if (state.treinoElaborado[exercicioIndex]['series'].length > 0) {
        state.treinoElaborado[exercicioIndex]['series'].forEach((item, index) => {
          const perc = parseFloat(item['perc_load'])
          if (perc > 0) {
            calcularCarga(exercicioIndex, index, 'perc')
          }
        })
      }
    }

    function mudaExercicioCardio(eventValue, element) {
      const exercicioIndex = state.treinoElaborado.findIndex((x) => x.id == element.id)
      const exercicioCardio = state.exercicios.find((x) => x.id == eventValue)
      state.treinoElaborado[exercicioIndex].exercise = exercicioCardio
      state.treinoElaborado[exercicioIndex].exercise_id = exercicioCardio.id
      state.treinoElaborado[exercicioIndex].max_load_test = exercicioCardio.max_load_test

      // Se for exercício de cardio, não processar series
      if (state.treinoElaborado[exercicioIndex].is_cardio) {
        return
      }

      if (state.treinoElaborado[exercicioIndex]['series'].length > 0) {
        state.treinoElaborado[exercicioIndex]['series'].forEach((item, index) => {
          const perc = parseFloat(item['perc_load'])
          if (perc > 0) {
            calcularCarga(exercicioIndex, index, 'perc')
          }
        })
      }
    }

    const carregarTodosExercicios = () => {
      exercicioRepository
        .ExercicioGet()
        .then((response) => {
          if (response.data.success) {
            state.exercicios = response.data.data
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar exercícios:', error)
        })
    }

    const carregarMetodos = () => {
      metodoRepository
        .MetodoGet()
        .then((response) => {
          if (response.data.success) {
            state.metodos = response.data.data
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar métodos:', error)
        })
    }

    const carregarModalidades = () => {
      modalidadeRepository
        .ModalidadeGet()
        .then((response) => {
          if (response.data.success) {
            state.modalidades = response.data.data
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar modalidades:', error)
        })
    }

    const getMetodoName = (methodId) => {
      if (!methodId) return 'N/A'
      const metodo = state.metodos.find((m) => m.id === methodId)
      return metodo ? metodo.name : 'N/A'
    }

    const getModalidadeName = (modalityId) => {
      if (!modalityId) return 'N/A'
      const modalidade = state.modalidades.find((m) => m.id === modalityId)
      return modalidade ? modalidade.name : 'N/A'
    }

    const getExerciseName = (exerciseId) => {
      if (!exerciseId) return 'N/A'
      const exercise = state.exercicios.find((e) => e.id === exerciseId)
      return exercise ? exercise.name : 'N/A'
    }

    function copiaZonas(index) {
      const exercise = state.treinoElaborado[index]

      // Se for exercício de cardio, não copiar zonas
      if (exercise.is_cardio) {
        return
      }

      const series = exercise['series'].map((item) => {
        return {
          load: item.load,
          perc_load: item.perc_load,
          repetitions: item.repetitions,
          series: item.series,
        }
      })
      console.log(series)

      store.commit('SET_SERIES', series)
    }

    function colarZonas(index) {
      const exercise = state.treinoElaborado[index]

      // Se for exercício de cardio, não colar zonas
      if (exercise.is_cardio) {
        return
      }

      const series = store.getters.getSeries

      if (parseInt(exercise['max_load_test']) > 0) {
        const maxLoadTest = parseInt(exercise['max_load_test'])
        series.forEach((item) => {
          let result = (maxLoadTest * parseFloat(item.perc_load)) / 100
          console.log(result)
          const obj = {
            perc_load: item.perc_load,
            repetitions: item.repetitions,
            series: item.series,
            load: result,
          }
          exercise['series'].push(obj)
        })
      } else {
        series.forEach((item) => {
          const obj = {
            perc_load: 0,
            repetitions: item.repetitions,
            series: item.series,
            load: item.perc_load,
          }
          exercise['series'].push(obj)
        })
      }
    }

    const CanPasteZones = computed(() => {
      return store.getters.getSeries
    })

    const pasteExercises = computed(() => {
      return store.getters.getCopyExercises.length > 0
    })

    // ✅ FUNÇÃO LISTAR EXERCÍCIOS PARA COPIAR
    function listaExerciciosParaCopiar(index) {
      state.treinoElaborado[index]['checkCopy'] = !state.treinoElaborado[index]['checkCopy']
    }

    // ✅ FUNÇÃO MARCAR TODOS
    function marcarTodos() {
      state.treinoElaborado.forEach((item) => {
        if ((item.series && item.series.length > 0) || item.is_cardio) {
          item['checkCopy'] = state.checkAll
        }
      })
    }

    // ✅ FUNÇÃO COPIAR EXERCÍCIOS SELECIONADOS
    function copiarExerciciosSelecionados() {
      let exercises = []
      state.treinoElaborado.forEach((item) => {
        if (item['checkCopy']) {
          exercises.push(item)
        }
      })
      store.commit('SET_COPY_EXERCISES', exercises)
    }

    function colarExerciciosSelecionados() {
      const items = store.getters.getCopyExercises
      console.log(items)

      items.forEach((item) => {
        let obj = {
          order: state.treinoElaborado.length + 1,
          exercise: Object.assign({}, item['exercise']),
          max_load_test: item['max_load_test'],
          exercise_id: item['exercise']['id'],
          series: item['series'],
        }
        console.log(obj)

        //verifica se o exercicio ja nao existe na lista para nao duplicar
        let duplicate = state.treinoElaborado.some((item) => item.exercise_id == obj.exercise_id)
        if (!duplicate) {
          state.treinoElaborado.push(obj)
        }
      })

      //state.treinoElaborado.push(store.getters.getSeries)
    }

    function adicionarIntervaloCardio(exerciseIndex) {
      const exercise = state.treinoElaborado[exerciseIndex]
      if (exercise.is_cardio && exercise.cardio_details) {
        const cardioType = getCardioMethodType(exercise)

        if (cardioType === 'continuo') {
          exercise.cardio_details.push({
            stage: '',
            time: '',
            distance: '',
            pace: '',
            vo2: '',
            fctr: '',
          })
        } else if (cardioType === 'intervalado') {
          exercise.cardio_details.push({
            stage: '',
            time: '',
            distance: '',
            recovery_time: '',
            load: '',
            fca: '',
          })
        } else {
          // Fallback para tipos não identificados
          exercise.cardio_details.push({
            stage: '',
            time: '',
            distance: '',
            load: '',
            fca: '',
          })
        }
      }
    }

    function removerIntervaloCardio(exerciseIndex, detailIndex) {
      const exercise = state.treinoElaborado[exerciseIndex]
      if (exercise.is_cardio && exercise.cardio_details && exercise.cardio_details.length > 1) {
        exercise.cardio_details.splice(detailIndex, 1)
      }
    }

    function eventChangeExerciseLoad(index, loadIndex) {
      const exercise = state.treinoElaborado[index]

      // Se for exercício de cardio, não processar
      if (exercise.is_cardio) {
        return
      }

      // Para exercícios de peso, calcular a carga
      calcularCarga(index, loadIndex)
    }

    // Função para determinar se um exercício de cardio é intervalado ou contínuo
    function getCardioMethodType(element) {
      if (
        !element ||
        (!element.is_cardio && !element.cardio_method_id && !element.cardio_modality_id)
      )
        return null

      const metodo = state.metodos.find((m) => m.id === element.cardio_method_id)
      if (!metodo) return null

      const methodName = metodo.name.toLowerCase()

      if (methodName.includes('intervalado')) {
        return 'intervalado'
      } else if (methodName.includes('contínuo') || methodName.includes('continuo')) {
        return 'continuo'
      }

      return null
    }

    // Computed property para verificar se há exercícios de cardio
    const hasCardioExercises = computed(() => {
      return state.treinoElaborado.some(
        (exercise) =>
          exercise.is_cardio ||
          exercise.cardio_modality_id ||
          exercise.cardio_method_id ||
          (exercise.cardio_details && exercise.cardio_details.length > 0),
      )
    })

    // Função para calcular métricas específicas de cardio
    function calcularCardioEstrategicos(tipo, listaIndex) {
      let exercise = state.treinoElaborado[listaIndex]
      if (
        !exercise ||
        (!exercise.is_cardio && !exercise.cardio_method_id && !exercise.cardio_modality_id)
      ) {
        return 0
      }

      if (!exercise.cardio_details || exercise.cardio_details.length === 0) return 0

      // Função auxiliar para converter tempo para segundos
      const tempoParaSegundos = (timeStr) => {
        if (!timeStr) return 0
        const timeParts = timeStr.split(':')
        let seconds = 0
        if (timeParts.length === 3) {
          // Formato HH:MM:SS
          seconds =
            parseInt(timeParts[0]) * 3600 + parseInt(timeParts[1]) * 60 + parseInt(timeParts[2])
        } else if (timeParts.length === 2) {
          // Formato MM:SS
          seconds = parseInt(timeParts[0]) * 60 + parseInt(timeParts[1])
        }
        return seconds
      }

      // Função auxiliar para formatar segundos em HH:MM:SS
      const segundosParaTempo = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600)
        const minutes = Math.floor((totalSeconds % 3600) / 60)
        const seconds = totalSeconds % 60
        return `${hours.toString().padStart(2, '0')}:${minutes
          .toString()
          .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
      }

      // Função auxiliar para formatar segundos em MM:SS
      const segundosParaTempoCurto = (totalSeconds) => {
        const minutes = Math.floor(totalSeconds / 60)
        const seconds = totalSeconds % 60
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
      }

      switch (tipo) {
        case 'ESTAGIO':
          return exercise.cardio_details.length

        case 'TEMPO_CONTINUO':
          // Para cardio contínuo, soma todos os tempos e retorna em formato HH:MM:SS
          const totalTempoContinuo = exercise.cardio_details.reduce((total, detail) => {
            return total + tempoParaSegundos(detail.time)
          }, 0)
          return segundosParaTempo(totalTempoContinuo)

        case 'TEMPO_INTERVALADO':
          // Para cardio intervalado, soma todos os tempos e retorna em formato MM:SS
          const totalTempoIntervalado = exercise.cardio_details.reduce((total, detail) => {
            return total + tempoParaSegundos(detail.time)
          }, 0)
          return segundosParaTempoCurto(totalTempoIntervalado)

        case 'DIST':
          return exercise.cardio_details.reduce((total, detail) => {
            return total + (parseInt(detail.distance) || 0)
          }, 0)

        case 'PACE':
          // Retorna o pace diretamente do campo salvo
          const paceValues = exercise.cardio_details
            .map((detail) => detail.pace)
            .filter((pace) => pace !== undefined && pace !== null && pace !== '')

          if (paceValues.length > 0) {
            const v = paceValues[0]
            return typeof v === 'string' ? v : v.toFixed(2)
          }
          return '0.00'

        case 'VO2':
          // Retorna o VO2 diretamente do campo salvo
          const vo2Values = exercise.cardio_details
            .map((detail) => detail.vo2_per_time)
            .filter((vo2) => vo2 !== undefined && vo2 !== null && vo2 !== '')

          if (vo2Values.length > 0) {
            const v = vo2Values[0]
            return typeof v === 'string' ? v : v.toFixed(2)
          }
          return '0'

        case 'FCTR':
          // Retorna a FCtr diretamente do campo salvo
          const fctrValues = exercise.cardio_details
            .map((detail) => detail.fctr)
            .filter((fctr) => fctr !== undefined && fctr !== null && fctr !== '')

          if (fctrValues.length > 0) {
            const v = fctrValues[0]
            return typeof v === 'string' ? v : v.toString()
          }
          return '0'

        case 'TEMPO_RECUPERACAO':
          // Para cardio intervalado, calcula tempo de recuperação (assumindo que é o tempo entre intervalos)
          const tempoRecuperacao = exercise.cardio_details.reduce((total, detail) => {
            // Assumindo que o tempo de recuperação está em um campo específico ou é calculado
            return total + tempoParaSegundos(detail.recovery_time || '00:00')
          }, 0)
          return segundosParaTempoCurto(tempoRecuperacao)

        case 'CARGA':
          // Retorna a carga diretamente do campo salvo
          const cargaValues = exercise.cardio_details
            .map((detail) => detail.load)
            .filter((carga) => carga !== undefined && carga !== null && carga !== '')

          if (cargaValues.length > 0) {
            const v = cargaValues[0]
            return typeof v === 'string' ? v : v.toString()
          }
          return '0'

        case 'FCA':
          // Retorna a FCA diretamente do campo salvo
          const fcaValues = exercise.cardio_details
            .map((detail) => detail.fca)
            .filter((fca) => fca !== undefined && fca !== null && fca !== '')

          if (fcaValues.length > 0) {
            const v = fcaValues[0]
            return typeof v === 'string' ? v : v.toString()
          }
          return '0'

        default:
          return 0
      }
    }

    // Função para totalizar métricas específicas de cardio
    function totalizadoresCardioEstrategicos(tipo) {
      let response = 0
      const cardioExercises = state.treinoElaborado.filter(
        (exercise) =>
          exercise.is_cardio ||
          exercise.cardio_method_id ||
          exercise.cardio_modality_id ||
          (exercise.cardio_details && exercise.cardio_details.length > 0),
      )
      cardioExercises.forEach((exercise) => {
        response += calcularCardioEstrategicos(tipo, state.treinoElaborado.indexOf(exercise))
      })
      return response
    }

    function apagarTodosExercicios() {
      swal({
        title: 'Tem certeza?',
        text: 'Deseja apagar TODOS os exercícios deste treino?',
        showCancelButton: true,
        confirmButtonText: 'Sim, apagar tudo!',
        cancelButtonText: 'Não, cancelar!',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-success',
          cancelButton: 'btn bg-gradient-danger',
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            store.commit('SET_SPLASH_SCREEN', true)

            // 🔹 Verifica se há exercícios já salvos no backend
            const ids = state.treinoElaborado
              .filter((x) => x.id)
              .map((x) => ({ id: x.id, cardio: !!x.is_cardio }))

            if (ids.length > 0) {
              // Deleta cada exercício de forma assíncrona
              const promises = ids.map((ex) =>
                ex.cardio
                  ? planosTreinoRepository.PlanoTreinoExerciciosCardioDiaDelete(ex.id)
                  : planosTreinoRepository.PlanoTreinoExerciciosDiaDelete(ex.id),
              )
              await Promise.all(promises)
            }

            // Limpa lista no estado local
            state.treinoElaborado = []

            store.commit('SET_SPLASH_SCREEN', false)

            swal({
              icon: 'success',
              title: 'Sucesso!',
              text: 'Todos os exercícios foram apagados.',
              customClass: { confirmButton: 'btn bg-gradient-success' },
              buttonsStyling: false,
            }).then(() => {
              refresh() // já existe no seu código
            })
          } catch (error) {
            store.commit('SET_SPLASH_SCREEN', false)
            swal({
              icon: 'error',
              title: 'Erro!',
              text: error.message,
            })
          }
        }
      })
    }

    function apagarExerciciosSelecionados() {
      // Conta quantos exercícios estão selecionados
      const selecionados = state.treinoElaborado.filter((x) => x.checkCopy)
      const quantidade = selecionados.length

      if (quantidade === 0) {
        swal({
          icon: 'warning',
          title: 'Atenção!',
          text: 'Nenhum exercício foi selecionado.',
        })
        return
      }

      swal({
        title: 'Tem certeza?',
        text: `Deseja apagar ${quantidade} exercício${quantidade > 1 ? 's' : ''} selecionado${quantidade > 1 ? 's' : ''}?`,
        showCancelButton: true,
        confirmButtonText: 'Sim, apagar!',
        cancelButtonText: 'Não, cancelar!',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-success',
          cancelButton: 'btn bg-gradient-danger',
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            store.commit('SET_SPLASH_SCREEN', true)

            let deletedCount = 0
            let errorCount = 0

            // Separar exercícios com ID (já salvos) dos sem ID (novos)
            const comId = selecionados.filter((x) => x.id)
            const semId = selecionados.filter((x) => !x.id)

            // Deletar do backend os exercícios já salvos
            if (comId.length > 0) {
              const promises = comId.map(async (ex) => {
                try {
                  if (ex.is_cardio) {
                    await planosTreinoRepository.PlanoTreinoExerciciosCardioDiaDelete(ex.id)
                  } else {
                    await planosTreinoRepository.PlanoTreinoExerciciosDiaDelete(ex.id)
                  }
                  deletedCount++
                } catch (error) {
                  console.error('Erro ao deletar exercício:', error)
                  errorCount++
                }
              })
              await Promise.all(promises)
            }

            console.log('🗑️ [TabelaExerciciosElaborados] Deletando múltiplos exercícios')
            console.log('📊 Antes:', state.treinoElaborado.length, 'exercícios')

            // ✅ FIX: Remover da lista local de forma mais segura
            // Filtrar removendo todos os selecionados de uma vez
            state.treinoElaborado = state.treinoElaborado.filter((ex) => !ex.checkCopy)

            console.log('📊 Depois:', state.treinoElaborado.length, 'exercícios')

            // Desmarcar checkbox "marcar todos" se estava marcado
            state.checkAll = false

            // ✅ Marcar flag antes de emitir
            isUpdatingFromChild = true
            // ✅ Emitir evento para atualizar o pai
            console.log('📤 Emitindo update:exerciciosProp')
            emit('update:exerciciosProp', [...state.treinoElaborado])

            store.commit('SET_SPLASH_SCREEN', false)

            let mensagem = ''
            if (errorCount === 0) {
              mensagem = `${quantidade} exercício${quantidade > 1 ? 's foram' : ' foi'} apagado${quantidade > 1 ? 's' : ''} com sucesso!`
            } else {
              mensagem = `${deletedCount} exercício${deletedCount > 1 ? 's foram' : ' foi'} apagado${deletedCount > 1 ? 's' : ''}. ${errorCount} erro${errorCount > 1 ? 's' : ''} ocorreu${errorCount > 1 ? 'ram' : ''}.`
            }

            swal({
              icon: errorCount === 0 ? 'success' : 'warning',
              title: errorCount === 0 ? 'Sucesso!' : 'Parcialmente concluído',
              text: mensagem,
              customClass: { confirmButton: 'btn bg-gradient-success' },
              buttonsStyling: false,
            })
            // ✅ FIX: NÃO fazer refresh automático para evitar recarregar exercícios deletados
          } catch (error) {
            store.commit('SET_SPLASH_SCREEN', false)
            swal({
              icon: 'error',
              title: 'Erro!',
              text: error.message,
            })
          }
        }
      })
    }

    return {
      state,
      pasteExercises,
      colarExerciciosSelecionados,
      CanPasteZones,
      addCargaExercicio,
      calcularCarga,
      removerSerie,
      calcularEstrategicos,
      salvar,
      deletarExercicio,
      deletarExercicioCardioConfirma,
      mudaExercicioTestado,
      totalizadoresEstrategicos,
      colarZonas,
      copiaZonas,
      adicionarIntervaloCardio,
      removerIntervaloCardio,
      eventChangeExerciseLoad,
      getMetodoName,
      getModalidadeName,
      getExerciseName,
      getCardioMethodType,
      hasCardioExercises,
      calcularCardioEstrategicos,
      totalizadoresCardioEstrategicos,
      calcularTotaisCardio,
      converterTempoParaSegundos,
      formatarSegundosParaTempo,
      apagarTodosExercicios,
      apagarExerciciosSelecionados,
      // ✅ EXPORTANDO NOVAS FUNÇÕES
      listaExerciciosParaCopiar,
      marcarTodos,
      copiarExerciciosSelecionados,
    }
  },
}
</script>

<style>
select.custom-select.form-control-sm {
  height: 32.39px;
}

/* Cores mais neutras e agradáveis para as caixas de carga, série e repetição */
.carga-input {
  background-color: #f5f5f5 !important;
  font-size: 0.9rem !important;
  font-weight: bold !important;
  color: #333 !important;
  text-align: center !important;
  border: 1px solid #e0e0e0 !important;
}

.serie-input {
  background-color: #e3ecfa !important;
  font-size: 0.9rem !important;
  font-weight: bold !important;
  color: #2a4d7a !important;
  text-align: center !important;
  border: 1px solid #b3c6e0 !important;
}

.repeticao-input {
  background-color: #e7f6ef !important;
  font-size: 0.9rem !important;
  font-weight: bold !important;
  color: #2e5d47 !important;
  text-align: center !important;
  border: 1px solid #b2dfdb !important;
}

.cardio-details {
  width: 100%;
}

.cardio-interval {
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  padding: 0.5rem;
  background-color: #f8f9fa;
}

.cardio-interval .form-label {
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.cardio-interval .form-control-sm {
  font-size: 0.75rem;
}

.cardio-exercise-name {
  background-color: #e3f2fd;
  padding: 0.5rem;
  border-radius: 0.375rem;
  border-left: 4px solid #2196f3;
}

.cardio-exercise-name strong {
  color: #1976d2;
}

.cardio-exercise-name small {
  color: #666;
}

/* Estilos para a tabela editável de cardio */
.cardio-details .table {
  margin-bottom: 0;
}

.cardio-details .table th {
  background-color: #f8f9fa;
  border-color: #dee2e6;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.5rem;
}

.cardio-details .table td {
  padding: 0.5rem;
  vertical-align: middle;
}

.cardio-details .table input {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  font-size: 0.75rem;
}

.cardio-details .table input:focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.cardio-details .btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

/* Cores mais neutras e agradáveis para as caixas de carga, série e repetição */
.carga-input {
  background-color: #f5f5f5 !important;
  font-size: 0.9rem !important;
  font-weight: bold !important;
  color: #333 !important;
  text-align: center !important;
  border: 1px solid #e0e0e0 !important;
}

.serie-input {
  background-color: #e3ecfa !important;
  font-size: 0.9rem !important;
  font-weight: bold !important;
  color: #2a4d7a !important;
  text-align: center !important;
  border: 1px solid #b3c6e0 !important;
}

.repeticao-input {
  background-color: #e7f6ef !important;
  font-size: 0.9rem !important;
  font-weight: bold !important;
  color: #2e5d47 !important;
  text-align: center !important;
  border: 1px solid #b2dfdb !important;
}
</style>
